import appSettings from "@/plumbing/ApplicationSettings";
import userStore from "@/store/userStore";

export function videoUrl(videoRequestId: number, camera: string) {
  return `${appSettings.apiBaseUrl}/api/videorequests/${videoRequestId}/${camera}/video?access_token=${userStore.user?.access_token}&Council=${userStore.activeCouncil}`;
}
